import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, isRef as _isRef, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "tw-question__title" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "tw-question__title__asterisk" }, " *", -1)
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["aria-invalid"]
const _hoisted_5 = ["id"]
const _hoisted_6 = ["checked", "id", "name", "aria-describedby", "onChange", "value"]
const _hoisted_7 = ["for"]
const _hoisted_8 = ["id"]

import { InterviewQuestionResponseModel, Variant } from '@/models/QuestionModels'
import { useInterviewStore } from '@/stores/interviewStore'
import FlatButton from '@/components/Shared/FlatButton.vue'
import { computed, onMounted, ref } from 'vue'
import { scrollToElementBottom } from '../scrollToElementBottom';


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckboxQuestion',
  props: {
    question: null,
    isStandAlone: { type: Boolean, default: true }
  },
  emits: ['handleAnswerChoose'],
  setup(__props: any, { emit: emits }) {

const props = __props as { question: InterviewQuestionResponseModel, isStandAlone: boolean };

const interviewStore = useInterviewStore()

const answers = ref<Variant[]>([])
const isSubmited = ref<boolean>(false)
const touched = ref<boolean>(false)




const nextBtnText = computed(() => interviewStore.getLocalization('InterviewQuestionary.Common.NextQuestionButton'))
const errorMessage = computed(() => interviewStore.questionsAnswerError[props.question.Id])
const isSubmitable = computed(() => {
    validateField()
    return answers.value?.length > 0
});

const root = ref<HTMLElement | undefined>(undefined);
onMounted(() => scrollToElementBottom(root!.value as HTMLElement));

function onAnswerChoose(variant: Variant) {
    if (!(variant && props.question.Id)) {
        return;
    }

    answers.value = isChecked(variant) ? [...answers.value.filter((i) => i.Label !== variant.Label)] : [...answers.value, { ...variant }];

    touched.value = true

    emits('handleAnswerChoose', variant)

    if (isSubmited.value) {
        submitQuestion();
    }
}

function isChecked(variant: Variant): boolean {
    return answers.value.map((i) => i.Label).includes(variant.Label)
}

function validateField() {
    if ((!answers.value || answers.value?.length === 0) && touched.value) {
        interviewStore.questionsAnswerError[props.question.Id] = interviewStore.getLocalization("Accessability.InterviewQuestionary.CheckboxField.Empty")
    } else{
        interviewStore.questionsAnswerError[props.question.Id] = null
    }
}

function submitQuestion() {
    if ((interviewStore.isLastQuestion && interviewStore.checkError()) || !isSubmitable.value) {
        return;
    }

    const answer = answers.value.map(ans => ans.Label!.trim()).join(';');

    interviewStore.changeAnswer(props.question.Id, answer);

    if (!isSubmited.value) {
        interviewStore.nextQuestion();
    }

    isSubmited.value = true
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "root",
    ref: root,
    class: "tw-question checkbox-question"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createTextVNode(_toDisplayString(__props.question.Title), 1),
      _hoisted_2
    ]),
    (!!__props.question.Description)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          innerHTML: __props.question.Description,
          class: "tw-question__description"
        }, null, 8, _hoisted_3))
      : _createCommentVNode("", true),
    _createElementVNode("fieldset", {
      class: "checkbox__group",
      "aria-required": true,
      "aria-invalid": !_unref(isSubmitable)
    }, [
      _createElementVNode("legend", {
        id: __props.question.Id + '_label',
        class: "d-none"
      }, _toDisplayString(__props.question.Label), 9, _hoisted_5),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.question.Variants, (btn, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "checkbox__item",
          key: `${__props.question.Id}_${index}`
        }, [
          _createElementVNode("input", {
            class: _normalizeClass(["checkbox__input", {
                        'tw-form-control__field-error--highlight': (!answers.value || answers.value?.length === 0) && touched.value
                    }]),
            type: "checkbox",
            checked: isChecked(btn),
            id: __props.question.Id+btn.Label,
            name: __props.question.Id+'checkbox',
            "aria-describedby": _unref(errorMessage) ? 'checkbox-question-error-' + __props.question.Id : __props.question.Id + '_label',
            onChange: ($event: any) => (onAnswerChoose(btn)),
            value: btn
          }, null, 42, _hoisted_6),
          _createElementVNode("label", {
            for: __props.question.Id+btn.Label,
            class: "checkbox__label"
          }, _toDisplayString(btn.Label), 9, _hoisted_7)
        ]))
      }), 128))
    ], 8, _hoisted_4),
    (_unref(errorMessage))
      ? (_openBlock(), _createElementBlock("span", {
          key: 1,
          id: 'checkbox-question-error-' + __props.question.Id,
          class: "tw-question__error",
          role: "alert",
          "aria-live": "polite"
        }, _toDisplayString(_unref(errorMessage)), 9, _hoisted_8))
      : _createCommentVNode("", true),
    (_unref(isSubmitable) && !isSubmited.value)
      ? (_openBlock(), _createBlock(FlatButton, {
          key: 2,
          onClick: submitQuestion,
          modelValue: _unref(nextBtnText),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(nextBtnText) ? (nextBtnText).value = $event : null)),
          bgColor: '#2C267A',
          isArrowStyle: true
        }, null, 8, ["modelValue"]))
      : _createCommentVNode("", true)
  ], 512))
}
}

})